module.exports = __webpack_public_path__ + "media/images/service/c_3-7de8a8bcd40da04b015739971057c044.png";